import { FooterEmailSignUpData, StoreIdentifierName } from 'types';
import { HomefieldIconPlIcon } from '@dsg-tech/homefield-react-icons';
import EmailSignUp from '../../../common/EmailSignUp/EmailSignUp';
import './FooterEmailSignUp.scss';

interface Props {
  footerEmailSignUpData: FooterEmailSignUpData[];
  storeIdentifierName: StoreIdentifierName;
}

export default function FooterEmailSignUp({
  footerEmailSignUpData,
  storeIdentifierName,
}: Readonly<Props>) {
  const setFooterText = (data: FooterEmailSignUpData) => {
    return (
      <>
        <h2 className="footerEmailSignUp-container__text-wrapper--title hmf-header-bold-m">
          {storeIdentifierName === 'pl' && (
            <HomefieldIconPlIcon className="footerEmailSignUp-container__text-wrapper--svg hmf-pr-xxxs" />
          )}
          {data.title}
        </h2>
        <p className="footerEmailSignUp-container__text-wrapper--description hmf-body-m">
          {data.description}
        </p>
        <EmailSignUp storeIdentifierName={storeIdentifierName} />
      </>
    );
  };

  return (
    <div data-testid="FooterEmailSignUp" className="footerEmailSignUp-container">
      {footerEmailSignUpData.map((data) => (
        <div
          data-testid="FooterEmailSignUp-item"
          className="footerEmailSignUp-container__content-wrapper hmf-display-flex hmf-justify-content-center"
          key={data.title}>
          <div className="footerEmailSignUp-container__text-wrapper hmf-p-m hmf-display-none hmf-display-l-block">
            {setFooterText(data)}
          </div>
          {data.visualAssets[0].map((imageContent) => (
            <img
              className="footerEmailSignUp-container__content-wrapper--image"
              key={imageContent.altText}
              src={imageContent.value}
              alt={imageContent.altText || ''}
            />
          ))}
          <div className="footerEmailSignUp-container__text-wrapper hmf-p-m hmf-display-l-none">
            {setFooterText(data)}
          </div>
        </div>
      ))}
    </div>
  );
}
